

















































































import { readUserProfile } from '@/store/main/getters';
import { Vue, Component, Prop } from 'vue-property-decorator';
import {FmvAvatar} from 'fmv-avatar';
import { api } from '@/api';
import CustomSelectInput from '@/components/vui-luma/Ui/CustomSelectInput.vue';
import {ISelectChoices} from '@/interfaces';

@Component({
  components: {
    FmvAvatar,
    CustomSelectInput,
  },
})
export default class LeadSettingsModal extends Vue {
  // @ts-ignore
  @Prop({required: true, default: false}) readonly public showModal: boolean;
  // @ts-ignore
  @Prop({required: true, default: null}) readonly public lead: any;
  // @ts-ignore
  @Prop({required: false, default: ''}) readonly public groupsFilter: string;
  public tagIds: any = [];
  public groupIds: any = [];
  // public status: any = null;
  public loadingState = {
    submit: false,
  };

  public mounted() {
    this.tagIds = this.lead.tags_ids;
    this.groupIds = this.lead.groups_ids;
    // this.status = this.lead.user_condition;
  }

  public resetForm() {
    this.$emit('close-modal');
  }

  public async handleSubmit() {
    try {
      const response = await api.updateLeadSettings(
        this.$store.getters.token,
        {
          // @ts-ignore
          user_id: this.lead.pk ? this.lead.pk: this.lead.id, tags: this.tagIds, groups: this.groupIds,
        },
      );
      // @ts-ignore
      this.showToast(this, this.$t('Lead settings updated'));
      this.$emit('created-event');
      this.resetForm();
    } catch (error) {
      // @ts-ignore
      if (error.response && error.response.data) {
        let errorMsg = '';
        // @ts-ignore
        for (const [key, value] of Object.entries(error.response.data)) {
          // @ts-ignore
          errorMsg += `${this.$t(key)} - ${value[0]}\n`;
        }
        // @ts-ignore
        this.showToast(this, errorMsg, 'error');
      } else {
        // @ts-ignore
        this.showToast(this, this.$t('Error'), 'error');
      }
    }
  }

  public handleChangeTag(value) {
    const newList: any = [];
    for (const [key, val] of Object.entries(value)) {
      // @ts-ignore
      newList.push(val.id);
    }
    this.tagIds = newList;
  }

  public handleChangeGroup(value) {
    const newList: any = [];
    for (const [key, val] of Object.entries(value)) {
      // @ts-ignore
      newList.push(val.id);
    }
    this.groupIds = newList;
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }
}
